import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { registerServiceWorker, setupOfflineDetection } from "./utils/serviceWorker";
// Internacionalização (i18n): inicializa o motor de tradução e a detecção
// automática de idioma por IP/navegador. Deve ser importado antes do render.
import { initializeLocale } from "./i18n";
import { initAttribution } from "./utils/attribution";

// First-touch UTMs / gclid / fbclid → localStorage (before React render)
initAttribution();

/** Garante o símbolo UpClinic na aba (substitui cache do átomo React). */
function ensureUpClinicFavicon() {
  const href = `${process.env.PUBLIC_URL || ""}/brand-mark-128.png?v=3`;
  const rels = ["icon", "shortcut icon"];
  rels.forEach((rel) => {
    let link = document.querySelector(`link[rel="${rel}"]`) as HTMLLinkElement | null;
    if (!link) {
      link = document.createElement("link");
      link.rel = rel;
      document.head.appendChild(link);
    }
    link.type = "image/png";
    link.href = href;
  });
}
ensureUpClinicFavicon();

/** Após deploy, abas antigas pedem chunks que não existem mais → HTML 404 → Unexpected token '<' */
function setupChunkLoadRecovery() {
  const RELOAD_KEY = 'upclinic_chunk_reload';
  const shouldReload = (msg: string) => {
    const m = (msg || '').toLowerCase();
    return (
      m.includes('chunkloaderror') ||
      m.includes('loading chunk') ||
      m.includes('loading css chunk') ||
      (m.includes('unexpected token') && m.includes('<'))
    );
  };
  const tryReload = () => {
    try {
      const last = Number(sessionStorage.getItem(RELOAD_KEY) || '0');
      if (Date.now() - last < 15000) return; // evita loop
      sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
      window.location.reload();
    } catch {
      window.location.reload();
    }
  };
  window.addEventListener('error', (ev) => {
    const msg = String(ev.message || ev.error?.message || '');
    if (shouldReload(msg)) tryReload();
  });
  window.addEventListener('unhandledrejection', (ev) => {
    const msg = String(ev.reason?.message || ev.reason || '');
    if (shouldReload(msg)) tryReload();
  });
}
setupChunkLoadRecovery();

// Suprimir console.log em produção para melhorar desempenho (especialmente em mobile)
if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
  console.debug = () => {};
}

// Dispara a detecção automática de idioma (por IP e navegador). Não bloqueia o
// render: a UI abre no idioma do navegador e é refinada quando o país é detectado.
// Só aplica automaticamente se o usuário ainda não escolheu um idioma manualmente.
void initializeLocale();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// App-shell SW desabilitado: limpa registro/cache legado (não registra de novo)
registerServiceWorker();
setupOfflineDetection();
